import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React, { useCallback } from "react";
import { useBookviewTabPanel } from "utilities/contexts/bookview-tab-panel/use-bookview-tab-panel";
import useNetworkInformation from "utilities/contexts/network-information/use-network-information";
import { useLocalization } from "utilities/hooks/use-localization";

const BASE_CLASS_NAME = "c-chat-panel-button";

const BookviewChatPanelButton: React.FC = () => {
    const { toggleBookviewChatPanel, isBookviewChatPanelOpen } =
        useBookviewTabPanel();
    const { isOnline } = useNetworkInformation();
    const { t } = useLocalization();

    const handleToggleBookviewChatPanel = useCallback(() => {
        toggleBookviewChatPanel();
    }, [toggleBookviewChatPanel]);

    const accessibleText = t("nav-aria-chat-link");

    const offlineClass = !isOnline ? "-offline" : "";

    return (
        <div className={`${BASE_CLASS_NAME} ${offlineClass}`}>
            <Button
                aria-label={accessibleText}
                aria-disabled={!isOnline}
                cssClassName={`${isBookviewChatPanelOpen ? "-panel-open" : ""}`}
                size={ButtonSizes.Small}
                style={ButtonStyles.TertiaryAlt}
                onClick={handleToggleBookviewChatPanel}>
                <Icon
                    size={IconSizes.Large}
                    type={Icons.Casi}
                    cssClassName="-casi"
                />
            </Button>
        </div>
    );
};

export default BookviewChatPanelButton;
